import { Action } from 'infra/types'
import {
  ACCOUNT_FILTER_TYPE,
  AccountsSpecificGroupDetails,
  AccountsSpecificGroupSummary,
  FETCH_ACCOUNTS_SUMMARY,
  IAccountsState,
  OverallStats
} from 'state/new-summary/accounts/accounts.types'

export const accountsAction = {
  SET_SPECIFIC_GROUP_SUMMARY: 'accounts/setSpecificGroupSummary',
  UN_SPECIFIC_ACCOUNTS_SUMMARY: 'accounts/unsetSpecificGroupSummary',
  SET_SPECIFIC_GROUP_DETAILS: 'accounts/setSpecificGroupDetails',
  SET_OVERALL_STATS: 'accounts/SET_OVERALL_STATS',
  SET_OVERALL_GROUP_STATS: 'accounts/SET_OVERALL_GROUP_STATS',
  SET_LOADERS: 'accounts/SET_LOADERS',
  FETCH_ACCOUNTS_SUMMARY: 'accounts/fetchAccountsSummary',
  FETCH_SPECIFIC_ACCOUNTS_SUMMARY: 'accounts/fetchSpecificAccountsSummary',
  DOWNLOAD_ACCOUNTS_SUMMARY: 'accounts/downloadAccountsSummary',
  DOWNLOAD_GROUP_ACCOUNTS_SUMMARY: 'accounts/downloadGroupAccountsSummary',
  SET_ACCOUNTS_SUMMARY_FILTER: 'accounts/setAccountsSummaryFilter'
}

export const setAccountsSummaryFilter = (payload: {
  startTime: number
  endTime: number
  filterType: ACCOUNT_FILTER_TYPE
}): Action<{
  startTime: number
  endTime: number
  filterType: ACCOUNT_FILTER_TYPE
}> => {
  return {
    type: accountsAction.SET_ACCOUNTS_SUMMARY_FILTER,
    payload
  }
}

export const setOverallStats = (payload: OverallStats): Action<OverallStats> => {
  return {
    type: accountsAction.SET_OVERALL_STATS,
    payload
  }
}

export const setOverallGroupsStats = (payload: OverallStats[]): Action<OverallStats[]> => {
  return {
    type: accountsAction.SET_OVERALL_GROUP_STATS,
    payload
  }
}

export const setAccountSummaryLoader = (payload: {
  loaderName: keyof IAccountsState['loaders']
  status: boolean
}): Action<{
  loaderName: keyof IAccountsState['loaders']
  status: boolean
}> => {
  return {
    type: accountsAction.SET_LOADERS,
    payload
  }
}

export const setAccountSpecificGroupSummary = (payload: AccountsSpecificGroupSummary) => {
  return {
    type: accountsAction.SET_SPECIFIC_GROUP_SUMMARY,
    payload
  }
}

export const setAccountSpecificGroupDetails = (payload: AccountsSpecificGroupDetails[]) => {
  return {
    type: accountsAction.SET_SPECIFIC_GROUP_DETAILS,
    payload
  }
}

export const fetchAccountsSummaryAction = (
  payload: FETCH_ACCOUNTS_SUMMARY
): Action<FETCH_ACCOUNTS_SUMMARY> => {
  return {
    type: accountsAction.FETCH_ACCOUNTS_SUMMARY,
    payload
  }
}

export const fetchSpecificAccountsSummaryAction = (
  payload: FETCH_ACCOUNTS_SUMMARY & { groupId: string }
): Action<FETCH_ACCOUNTS_SUMMARY & { groupId: string }> => {
  return {
    type: accountsAction.FETCH_SPECIFIC_ACCOUNTS_SUMMARY,
    payload
  }
}

export const unsetSpecificGroupData = () => {
  return {
    type: accountsAction.UN_SPECIFIC_ACCOUNTS_SUMMARY
  }
}

export const downloadAccountsSummaryAction = () => {
  return {
    type: accountsAction.DOWNLOAD_ACCOUNTS_SUMMARY
  }
}

export const downloadGroupAccountSummaryAction = (payload: {
  groupId: string
  groupName: string
}): Action<{
  groupId: string
  groupName: string
}> => {
  return {
    type: accountsAction.DOWNLOAD_GROUP_ACCOUNTS_SUMMARY,
    payload
  }
}
